import React from "react";

function Footer() {
  return (
    <footer>
      <div className="container">
        <p>&copy; 2022 SEO Suits</p>
      </div>
    </footer>
  );
}

export default Footer;
